




























































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, namespace } from 'vuex-class';

/**
 * Utils
 */
import { agentLogin } from "@/utils/auth";

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import authenticationAPI from '@/api/authentication';

/**
 * Types
 */
import { PayloadCredentialsRequest } from '@/api/authentication';
import { SettingsResponseModel } from '@/api/settings';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');


/**
 * Page de login d'agent.
 */
@Component({ mixins: [mixinsAPI] })
export default class AgentLoginPage extends Vue {
	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	credentials = new PayloadCredentialsRequest();

	/** Méthodes */
	async handleLogin() {
		this.isLoading = true;
		try {
			await agentLogin(this.credentials, this.$router);
		}
		catch (err) {
			(this as any).handleAPIError(err);
			this.isLoading = false;
		}
	}
}
